onComplete(function () {
	// Add code here.
	const isMobile = window.matchMedia("(max-width: 991px)").matches;
	const PAGE_SCROLL_THRESHOLD = isMobile ? 50 : 100;

	window.addEventListener('scroll', () => {
		const scroll = window.pageYOffset || document.documentElement.scrollTop;

		const navHeader = document.querySelectorAll('.nav-header');
		const mouseEls = document.querySelectorAll('.mouse');

		if (scroll >= PAGE_SCROLL_THRESHOLD) {
			navHeader.forEach(el => el.classList.add('scroll'));
		} else {
			navHeader.forEach(el => el.classList.remove('scroll'));
		}

		if (scroll > 50) {
			mouseEls.forEach(el => el.classList.add('scroll'));
		} else {
			mouseEls.forEach(el => el.classList.remove('scroll'));
		}
	})

	// accordion

	const setup = () => {
		const wrapper = document.querySelector('[id="image-accordion-wrapper"]');
		if (!wrapper) {
			return;
		}
		let openFirst = wrapper.getAttribute('data-open-first');
		openFirst = openFirst && openFirst !== 'false';

		const accordionImages = Array.from(
			wrapper.querySelectorAll('[data-partial="image"]')
		);
		const accordionItems = Array.from(
			wrapper.querySelectorAll('.collapse')
		);
		const setupItem = (index, item, image) => {
			const $item = $(item);
			if (index !== 0) {
				image.setAttribute('hidden', true);
			} else if (openFirst) {
				$item.collapse('show');
			}
			$item.on('shown.bs.collapse', function () {
				image.removeAttribute('hidden');
				for (let i = 0; i < accordionImages.length; i++) {
					if (accordionImages[i] !== image) {
						accordionImages[i].setAttribute('hidden', true);
					}
				}
			});
		}
		for (let i = 0; i < accordionItems.length; i++) {
			setupItem(i, accordionItems[i], accordionImages[i]);
		}
	}

	setup()
	if (window.editor) {
		window.editor.addEventListener('reloaded', setup);
	}
});